export class Bill {
  billNumber: number;
  billDate: string;
  dueAmount: number;
  customerId: number;
  meterId: number;
  billUnitRate: number;
  unitsConsumed: number;
  billAmount: number;
  billPaidStatus: string;
  billPaidDate: string;
  billRemarks: string;
  billProof: string;
  currentReading: number;
  employeeId: number;
  previousUnitsConsumed: number;
  previousReading: number;
  badDebt: number;
  discount: number;
  vat: number;
  qiyaas: boolean;
  qiyaasAmount: number;
  qiyaasReading: number;

  pa?:number;
  wadarta?:number;
  rh?:number;
  finalBillDueAmount?: number;
  textMsg?:string;
  paymentRemark?:string;
  partialAmount?:number;
  sendSms?:boolean;
}
